import { useState, useEffect } from 'react';
import axios from 'axios';
import { X, Play, Heart } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function FoundersWelcome({ onClose }) {
  const [welcome, setWelcome] = useState(null);

  useEffect(() => {
    loadWelcome();
  }, []);

  const loadWelcome = async () => {
    try {
      const res = await axios.get(`${API}/settings/welcome`);
      setWelcome(res.data);
    } catch (e) {
      setWelcome({
        title: 'Welcome to Pivot To Power',
        message: 'We built this network because we believe in the power of community, strategy, and AI to transform lives.',
        video_url: ''
      });
    }
  };

  if (!welcome) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" data-testid="founders-welcome-modal">
      <div className="bg-white rounded-2xl max-w-lg w-full shadow-2xl overflow-hidden animate-fadeIn">
        {/* Purple banner */}
        <div className="bg-gradient-to-r from-purple-700 via-purple-600 to-pink-600 px-6 py-5 flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <img src="https://customer-assets.emergentagent.com/job_clarity-network-1/artifacts/b1jdxi6j_image.png" alt="" className="w-10 h-10 rounded-full border-2 border-white/30" />
            <div>
              <h2 className="text-lg font-cormorant font-bold text-white">{welcome.title}</h2>
              <p className="text-white/60 text-xs font-inter">From the Founders</p>
            </div>
          </div>
          <button onClick={onClose} className="text-white/60 hover:text-white transition-colors" data-testid="close-welcome-modal">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Video placeholder */}
        <div className="px-6 pt-6">
          {welcome.video_url ? (
            <div className="rounded-xl overflow-hidden mb-4">
              <video src={welcome.video_url} controls className="w-full rounded-xl" />
            </div>
          ) : (
            <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-8 flex flex-col items-center justify-center mb-4 border border-purple-100" data-testid="video-placeholder">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-600 to-pink-500 rounded-full flex items-center justify-center mb-3 shadow-lg shadow-purple-200">
                <Play className="w-8 h-8 text-white ml-1" />
              </div>
              <p className="text-purple-700 font-inter text-sm font-medium">Founders video coming soon</p>
              <p className="text-gray-400 text-xs font-inter mt-1">Check back for a personal welcome message</p>
            </div>
          )}
        </div>

        {/* Message */}
        <div className="px-6 pb-6">
          <p className="text-gray-600 font-inter text-sm leading-relaxed mb-6">{welcome.message}</p>
          <button onClick={onClose}
            className="w-full bg-gradient-to-r from-purple-600 to-pink-500 text-white font-inter font-bold py-3 rounded-xl hover:shadow-lg hover:shadow-purple-200 transition-all flex items-center justify-center space-x-2"
            data-testid="welcome-get-started-button">
            <Heart className="w-4 h-4" />
            <span>Let's Get Started</span>
          </button>
        </div>
      </div>
    </div>
  );
}
